var map = {
	"./card-aboniment-preview.jpg": 4020,
	"./card-building-preview.jpg": 9180,
	"./card-cleaning-preview.jpg": 8804,
	"./card-flowers-preview.jpg": 6800,
	"./card-grass-preview.jpg": 5404,
	"./card-monument-preview.jpg": 1724,
	"./card-monument-restouration-preview.jpg": 4396,
	"./card-restouration-preview.jpg": 9204,
	"./card-sand-preview.jpg": 3340
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4696;